import React from 'react';
import '../css/NavBar.css';

import navbar from '../data/navbar.json';

import Link from '../composant/Link';
import Images from '../composant/Images';

const Navbar = () => {
    var data = navbar.data.attributes.navbar;
    return (
        <nav class="navbar">
            <div class="logo-container">
                <a href='/'>
                    <Images data={data.img}></Images>
                </a>
            </div>
            <ul className='nav-links'>
                <Link data={data.Lien} className="nav-links"></Link>
                <Link data={data.Liens} className="nav-links"></Link>
            </ul>
            <script>
                {
                   window.onscroll = function() {
                       const navbar = document.querySelector('.navbar');
                       if(document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                           navbar.classList.add('active');
                       }
                       else{
                           navbar.classList.remove('active');
                       }
                   }
               }
            </script>
        </nav>
    );
}

export default Navbar;
